import { observer } from "mobx-react-lite";
import React, { useEffect, useRef, useState } from "react";
import { Loading } from "src/components";
import {
  CookieNames,
  fromEnv,
  isSdkFlow,
  loggerSetUser,
  setHeraCookie,
} from "src/helpers";
import { useHistory } from "react-router-dom";
import { PassportStoreContext, usePassportStore } from "src/stores";
import { HERA_BASE_URL, SDK_BASE_URL } from "src/constants";

const HERA_LOGIN = `${HERA_BASE_URL}/login`;
const SDK_LOGIN = `${SDK_BASE_URL}/login`;

const redirectToDashboard = () => {
  window.location.href = isSdkFlow() ? SDK_BASE_URL : HERA_BASE_URL;
};

const redirectToLogin = () => {
  if (isSdkFlow()) {
    window.location.href = SDK_LOGIN;
  } else {
    setHeraCookie(CookieNames.CurrentPath, fromEnv("REACT_APP_HOST"));
    window.location.href = HERA_LOGIN;
  }
};

export const PassportAuthProvider = observer(({ children }: any) => {
  const { location, replace } = useHistory();
  const context = usePassportStore();
  const { loadingState, isAuthenticated, authUser, outlet } = context;

  const [initState, setInitState] = useState(false);

  const userLoggedRef = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        await context.getCurrentUser();
        await context.getUserOutlet();
        await context.getActivation();
        replace(location.pathname);
      } catch {
        // noop
      } finally {
        setInitState(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading =
    loadingState.has.getCurrentUser ||
    loadingState.has.getUserOutlet ||
    loadingState.has.getActivation ||
    !initState;

  useEffect(() => {
    if (authUser?.id && !userLoggedRef.current) {
      loggerSetUser({
        id: String(authUser.id),
        email: authUser.email,
        name: authUser.fullName,
      });
      userLoggedRef.current = true;
    }
  }, [authUser]);

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    redirectToLogin();
    return <Loading />;
  }

  if (!authUser.isAdmin || !outlet.allowPassportOnboarding) {
    redirectToDashboard();
    return <Loading />;
  }

  return (
    <PassportStoreContext.Provider value={context}>
      {children}
    </PassportStoreContext.Provider>
  );
});
